import { render, staticRenderFns } from "./SideTagsSubtask.vue?vue&type=template&id=27410cc4&scoped=true&"
import script from "./SideTagsSubtask.vue?vue&type=script&lang=js&"
export * from "./SideTagsSubtask.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsSubtask.vue?vue&type=style&index=0&id=27410cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27410cc4",
  null
  
)

export default component.exports